import React from 'react';

function Footer() {
  return (
    <footer>
      <span className="blur"></span>
      <span className="blur"></span>

      <div className="socials">
        <a href="https://github.com/pAnderDev"><i className="ri-github-line"></i></a>
        <a href="https://www.linkedin.com/in/patrick-k-anderson/"><i className="ri-linkedin-box-fill"></i></a>
      </div>
    </footer>
  );
}

export default Footer;
